import { cn } from 'noddi-ui-common';
import { useIsMobile } from '../../hooks/useIsMobile';
import { NoddiCard, NoddiCardProps } from './NoddiCard';

interface NoddiResponsiveCardProps extends NoddiCardProps {
  /**
   * Whether to wrap content in a card on desktop.
   * On mobile, card styling is always removed for better UX.
   */
  wrapInCard?: boolean;
}

/**
 * A responsive wrapper around NoddiCard that automatically removes card styling on mobile
 * for better mobile UX while maintaining card appearance on desktop when desired.
 */
export function NoddiResponsiveCard({ className, wrapInCard = true, ...props }: NoddiResponsiveCardProps) {
  const isMobile = useIsMobile();

  return (
    <NoddiCard
      {...props}
      className={cn(
        // No card fill left to sit on, so hand --ambient-surface back to whatever is actually behind.
        // Important because the reset and the variant's own declaration are the same property at the
        // same specificity on this element, so plain class order would not decide it.
        (!wrapInCard || isMobile) &&
          'rounded-none border-none bg-transparent p-0 shadow-none [--ambient-surface:inherit]!',
        className
      )}
    />
  );
}
